export default __webpack_public_path__ + "static/media/voice_slider004.6f02eba9.png";